import { Util, Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/uaapi/uaa/";

//获取密码公钥
export function post_passwdPublicKey(config) {
  return XtAxios.post(URL + `authorize/passwd/publicKey`, null, config);
}
